// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/tag.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ApplyTagsRequest, ApplyTagsResponse, BulkTagEntitiesRequest, BulkTagEntitiesResponse, CreateTagGroupRequest, CreateTagRequest, CreateTagRuleRequest, DeleteTagGroupRequest, DeleteTagRequest, DeleteTagRuleRequest, GetEntityTagsRequest, GetEntityTagsResponse, GetTagRequest, GetTagSuggestionsRequest, GetTagSuggestionsResponse, ListTagGroupsRequest, ListTagGroupsResponse, ListTagRulesRequest, ListTagRulesResponse, ListTagsRequest, ListTagsResponse, RemoveTagsRequest, RemoveTagsResponse, ReplaceTagsRequest, ReplaceTagsResponse, StreamTagEventsRequest, Tag, TagEvent, TagGroup, TagRule, UpdateTagGroupRequest, UpdateTagRequest, UpdateTagRuleRequest } from "./tag_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.TagService
 */
export const TagService = {
  typeName: "omnios.v1.TagService",
  methods: {
    /**
     * Tag CRUD
     *
     * @generated from rpc omnios.v1.TagService.CreateTag
     */
    createTag: {
      name: "CreateTag",
      I: CreateTagRequest,
      O: Tag,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.UpdateTag
     */
    updateTag: {
      name: "UpdateTag",
      I: UpdateTagRequest,
      O: Tag,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.DeleteTag
     */
    deleteTag: {
      name: "DeleteTag",
      I: DeleteTagRequest,
      O: Tag,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.GetTag
     */
    getTag: {
      name: "GetTag",
      I: GetTagRequest,
      O: Tag,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.ListTags
     */
    listTags: {
      name: "ListTags",
      I: ListTagsRequest,
      O: ListTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Tag Group CRUD
     *
     * @generated from rpc omnios.v1.TagService.CreateTagGroup
     */
    createTagGroup: {
      name: "CreateTagGroup",
      I: CreateTagGroupRequest,
      O: TagGroup,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.UpdateTagGroup
     */
    updateTagGroup: {
      name: "UpdateTagGroup",
      I: UpdateTagGroupRequest,
      O: TagGroup,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.DeleteTagGroup
     */
    deleteTagGroup: {
      name: "DeleteTagGroup",
      I: DeleteTagGroupRequest,
      O: TagGroup,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.ListTagGroups
     */
    listTagGroups: {
      name: "ListTagGroups",
      I: ListTagGroupsRequest,
      O: ListTagGroupsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Entity tagging
     *
     * @generated from rpc omnios.v1.TagService.ApplyTags
     */
    applyTags: {
      name: "ApplyTags",
      I: ApplyTagsRequest,
      O: ApplyTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.RemoveTags
     */
    removeTags: {
      name: "RemoveTags",
      I: RemoveTagsRequest,
      O: RemoveTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.ReplaceTags
     */
    replaceTags: {
      name: "ReplaceTags",
      I: ReplaceTagsRequest,
      O: ReplaceTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.GetEntityTags
     */
    getEntityTags: {
      name: "GetEntityTags",
      I: GetEntityTagsRequest,
      O: GetEntityTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.BulkTagEntities
     */
    bulkTagEntities: {
      name: "BulkTagEntities",
      I: BulkTagEntitiesRequest,
      O: BulkTagEntitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Automation rules
     *
     * @generated from rpc omnios.v1.TagService.CreateTagRule
     */
    createTagRule: {
      name: "CreateTagRule",
      I: CreateTagRuleRequest,
      O: TagRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.UpdateTagRule
     */
    updateTagRule: {
      name: "UpdateTagRule",
      I: UpdateTagRuleRequest,
      O: TagRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.DeleteTagRule
     */
    deleteTagRule: {
      name: "DeleteTagRule",
      I: DeleteTagRuleRequest,
      O: TagRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TagService.ListTagRules
     */
    listTagRules: {
      name: "ListTagRules",
      I: ListTagRulesRequest,
      O: ListTagRulesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AI suggestions
     *
     * @generated from rpc omnios.v1.TagService.GetTagSuggestions
     */
    getTagSuggestions: {
      name: "GetTagSuggestions",
      I: GetTagSuggestionsRequest,
      O: GetTagSuggestionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Real-time events
     *
     * @generated from rpc omnios.v1.TagService.StreamTagEvents
     */
    streamTagEvents: {
      name: "StreamTagEvents",
      I: StreamTagEventsRequest,
      O: TagEvent,
      kind: MethodKind.ServerStreaming,
    },
  }
};

